import { css } from 'goober';
import { isEmpty } from 'mc-ui-utils';
import React, { memo, useCallback, useEffect, useState, } from 'react';
import constants from '../../../constants';
import { UIElement } from '../../../enums/UIElement';
import State from '../../../state';
import colors from '../../../styles/colors';
import font, { fontBase } from '../../../styles/font';
import { transparentize } from '../../../styles/mixins';
import { checkUserHasLiked, toggleLikeGlance } from '../../../utils/bubble';
import { d, humanize } from '../../../utils/common';
import { getCTA } from '../../../utils/data';
import { hasKhazaddumBridge, likeGlance, onShare as onBridgeShare, openCTAView, unLikeGlance, } from '../../../utils/khazaddumbridge';
import GenericShareIcon from '../../GenericShareIcon';
import HeartIcon from '../../HeartIcon';
import ThreeDots from '../../ThreeDots';
import WhatsappShare from '../../WhatsappShareIcon';
const ShareIcon = css `
  width: 22px;
  height: 22px;
  background-size: contain;
  background-repeat: no-repeat;
  display: block;
  margin-bottom: 4px;
`;
export const CTA = css `
  border-radius: 6px;
  border: 1px solid ${transparentize(0.49, colors.white)};
  color: ${colors.white};
  font-size: ${11 / fontBase}rem;
  font-weight: ${font.fontWtExtraBold};
  line-height: 1.18;
  letter-spacing: -0.03px;
  text-align: center;
  padding: 10px 15.6px 10.5px 14.1px;
  background-color: transparent;
  text-decoration: none;
  text-transform: uppercase;
  display: inline-block;
  &:active,
  &:focus {
    outline: none;
  }
`;
export const Stat = css `
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 8px;
  padding-bottom: 8px;
  color: ${colors.white};
  text-decoration: none;
  width: 27px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;
export const StatMore = css `
  height: 33px;
  justify-content: end;
  justify-content: flex-end;
  margin-bottom: 5px;
  padding-bottom: 11px;
`;
const bridgeShare = (glanceId, shareUrl, bubbleEvent) => {
    /**
     * this callback function will be called after the share activity is over and control is back to highlights
     */
    window.menuCloseCb = () => {
        window.onScreenVisibilityChange(true, "Share" /* SHARE */);
    };
    window.onScreenVisibilityChange(false, "Share" /* SHARE */);
    if (State.hasWhatsAppInstalled) {
        onBridgeShare(glanceId, shareUrl, constants.WHATSAPP_SHARE, 'window.menuCloseCb');
        bubbleEvent.setGlanceShared(glanceId, constants.WHATSAPP_SHARE);
    }
    else {
        onBridgeShare(glanceId, shareUrl, null, 'window.menuCloseCb');
        bubbleEvent.setGlanceShared(glanceId, 'generic');
    }
};
const CTActions = ({ glance, toggleDrawerMenu, toggleAutoPlay, bubbleEvent, isWebpeek, hiddenElements, index, }) => {
    const { glanceId, hasUserLiked, likeCount, shareCount, shareUrl } = glance;
    const [liked, setLiked] = useState(() => glance.hasUserLiked || checkUserHasLiked(glanceId));
    const glanceString = JSON.stringify(glance);
    const ctaText = getCTA(glance);
    const bottomGap = State.fromSportsPage ? `60px` : d.glanceBottomGap;
    const CTAContainer = css `
    flex-grow: 1;
    justify-content: flex-start;
    position: absolute;
    bottom: ${bottomGap};
    left: 14px;
  `;
    const Stats = css `
    font-size: ${9 / fontBase}rem;
    font-weight: ${font.fontWtMedium};
    line-height: 1.22;
    letter-spacing: 0.03px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    bottom: ${bottomGap};
    right: 24px;
  `;
    const onCTAClick = useCallback(() => {
        if (!State.isSdk) {
            toggleAutoPlay();
            State.onClickCTA(glance, index);
        }
        const startTime = Date.now();
        window.continueAutoPlay = () => {
            toggleAutoPlay();
            const duration = Date.now() - startTime;
            bubbleEvent.setGlanceCTADetails(glanceId, duration, 0, 0, startTime);
        };
        toggleAutoPlay();
        openCTAView(glanceString, 'window.continueAutoPlay');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [glanceString, toggleAutoPlay]);
    useEffect(() => {
        const liked = hasUserLiked || checkUserHasLiked(glanceId);
        setLiked(liked);
    }, [hasUserLiked, glanceId]);
    const onShare = useCallback(() => {
        if (!State.isSdk) {
            State.onClickShare(glance);
        }
        else if (hasKhazaddumBridge()) {
            bridgeShare(glanceId, shareUrl, bubbleEvent);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [glanceId, shareUrl]);
    const onLike = useCallback(() => {
        if (!glanceId)
            return;
        if (!State.isSdk) {
            const isLiked = State.onClickLike(glance);
            setLiked(isLiked);
            return;
        }
        const isLiked = toggleLikeGlance(glanceId);
        isLiked ? likeGlance(glanceId) : unLikeGlance(glanceId);
        bubbleEvent.setGlanceLikeState(glanceId, isLiked);
        setLiked(isLiked);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [glanceId]);
    useEffect(() => {
        const liked = hasUserLiked || checkUserHasLiked(glanceId);
        setLiked(liked);
    }, [glanceId, hasUserLiked]);
    const showThreeDots = !hiddenElements[UIElement.meatballsIcon] && State.isSdk;
    const showShare = glance.isShareable &&
        !State.disableShare &&
        !hiddenElements[UIElement.shareContainer];
    const showHeartIcon = !hiddenElements[UIElement.likeContainer];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: CTAContainer }, !isEmpty(ctaText) && !isWebpeek && (React.createElement("span", { className: CTA, onClick: onCTAClick }, ctaText))),
        React.createElement("div", { className: Stats },
            showThreeDots ? (React.createElement("div", { className: `${Stat} ${StatMore}`, onClick: toggleDrawerMenu },
                React.createElement(ThreeDots, null))) : null,
            showShare ? (React.createElement("div", { className: Stat, onClick: onShare },
                React.createElement("i", { className: ShareIcon },
                    State.hasWhatsAppInstalled ? (React.createElement(WhatsappShare, null)) : (React.createElement(GenericShareIcon, null)),
                    ' '),
                humanize(shareCount))) : null,
            showHeartIcon ? (React.createElement("div", { className: Stat, onClick: onLike },
                React.createElement(HeartIcon, { liked: liked }),
                humanize(likeCount + (liked ? 1 : 0)))) : null)));
};
const shouldNotRender = (prevProps, nextProps) => {
    if (JSON.stringify(prevProps.hiddenElements) !==
        JSON.stringify(nextProps.hiddenElements)) {
        return false;
    }
    return prevProps.glance.glanceId === nextProps.glance.glanceId;
};
CTActions.defaultProps = {
    hiddenElements: {},
};
export default memo(CTActions, shouldNotRender);
//# sourceMappingURL=index.js.map